import { render, staticRenderFns } from "./CacaoDataList.vue?vue&type=template&id=020867bc&scoped=true"
import script from "./CacaoDataList.vue?vue&type=script&lang=js"
export * from "./CacaoDataList.vue?vue&type=script&lang=js"
import style0 from "./CacaoDataList.vue?vue&type=style&index=0&id=020867bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020867bc",
  null
  
)

export default component.exports